import { useState } from 'react'
import { fetcher, AdminLevelRewardsEndpoints, IUseLevelRewards } from '@olagg/api-hooks'
import { AdminLevelReward } from '@olagg/db-types'

interface LevelRewardsResponse {
  levelRewards: AdminLevelReward[]
  meta: {
    count: number
  }
}

const useLevelRewards = () => {
  const [loading, setLoading] = useState(false)

  const getLevelRewards = async (filter: IUseLevelRewards): Promise<LevelRewardsResponse> => {
    try {
      setLoading(true)
      const endpoint = AdminLevelRewardsEndpoints.all(filter)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error fetching level rewards:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const getLevelReward = async (id: string): Promise<AdminLevelReward> => {
    try {
      setLoading(true)
      const endpoint = AdminLevelRewardsEndpoints.find(id)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error fetching level reward:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const createLevelReward = async (data: Partial<AdminLevelReward>): Promise<AdminLevelReward> => {
    try {
      setLoading(true)
      const endpoint = AdminLevelRewardsEndpoints.create(data)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error creating level reward:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const updateLevelReward = async (id: string, data: Partial<AdminLevelReward>): Promise<AdminLevelReward> => {
    try {
      setLoading(true)
      const endpoint = AdminLevelRewardsEndpoints.update(id, data)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error updating level reward:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const deleteLevelReward = async (id: string): Promise<void> => {
    try {
      setLoading(true)
      const endpoint = AdminLevelRewardsEndpoints.delete(id)
      await fetcher(endpoint)
    } catch (error) {
      console.error('Error deleting level reward:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    getLevelRewards,
    getLevelReward,
    createLevelReward,
    updateLevelReward,
    deleteLevelReward
  }
}

export default useLevelRewards
